
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'

import { t } from '@nextcloud/l10n'

import NcButton from '@nextcloud/vue/dist/Components/NcButton.js'
import NcNoteCard from '@nextcloud/vue/dist/Components/NcNoteCard.js'
import NcUserBubble from '@nextcloud/vue/dist/Components/NcUserBubble.js'

import AvatarWrapper from '../AvatarWrapper/AvatarWrapper.vue'

import { useIsDarkTheme } from '../../composables/useIsDarkTheme.ts'
import { AVATAR } from '../../constants.js'

export default {
	name: 'NewMessageAbsenceInfo',

	components: {
		AvatarWrapper,
		ChevronUp,
		NcButton,
		NcNoteCard,
		NcUserBubble,
	},

	props: {
		userAbsence: {
			type: Object,
			required: true,
		},

		displayName: {
			type: String,
			required: true,
		},
	},

	setup() {
		const isDarkTheme = useIsDarkTheme()
		return {
			AVATAR,
			isDarkTheme,
		}
	},

	data() {
		return {
			collapsed: true,
			isTextMoreThanOneLine: false,
		}
	},

	computed: {
		token() {
			return this.$store.getters.getToken()
		},

		userAbsenceCaption() {
			return t('spreed', '{user} is out of office and might not respond.', { user: this.displayName })
		},

		userAbsenceMessage() {
			return this.userAbsence.message || this.userAbsence.shortMessage
		},
	},

	watch: {
		userAbsenceMessage() {
			this.$nextTick(() => {
				this.setIsTextMoreThanOneLine()
			})
		},
	},

	mounted() {
		this.setIsTextMoreThanOneLine()
	},

	methods: {
		t,
		toggleCollapsed() {
			this.collapsed = !this.collapsed
		},

		setIsTextMoreThanOneLine() {
			this.isTextMoreThanOneLine = this.$refs.absenceMessage?.scrollHeight > this.$refs.absenceMessage?.clientHeight
		},

		async openConversationWithReplacementUser() {
			this.$router.push({
				name: 'root',
				query: {
					callUser: this.userAbsence.replacementUserId,
				}
			}).catch(err => console.debug(`Error while pushing the new conversation's route: ${err}`))
		},
	},
}
